<template>
  <el-scrollbar wrapClass="scrollbar-wrapper">
    <hamburger class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger>
    <el-menu
      mode="vertical"
      :show-timeout="200"
      :default-active="$route.path"
      :collapse="isCollapse"
      text-color="#333333"
      active-text-color="#148cdc"
    >
      <div class="nav-name">{{routeTitle}}</div>
      <sidebar-item v-for="route in routeList" :key="route.name" :item="route" :base-path="route.path" :parent-name="curParent"></sidebar-item>
    </el-menu>
  </el-scrollbar>
</template>

<script type="text/ecmascript-6">
import { mapGetters } from 'vuex'
import Hamburger from '@/components/Hamburger'
import SidebarItem from './SidebarItem'

export default {
  components: {
    SidebarItem,
    Hamburger
  },
  computed: {
    ...mapGetters([
      'permission_routers',
      'sidebar'
    ]),
    isCollapse() {
      return !this.sidebar.opened
    },
    parent() {
      let val = ''
      if (this.$route.meta.parent instanceof Array) {
        val = this.$route.meta.parent[0]
      } else {
        val = this.$route.meta.parent?this.$route.meta.parent:''
      }
      return val
    }
  },
  data() {
    return {
      routeTitle:'',
      routeList:null,
      curParent:this.parent,
    }
  },
  watch: {
    '$route'(to, from) {
      const toRoot = to.meta.root
      const fromRoot = from.meta.root

      if (to.meta.parent instanceof Array) {
        this.curParent=to.meta.parent.indexOf(from.name)!=-1?from.name:''
      } else {
        this.curParent=to.meta.parent?to.meta.parent:''
      }
      
      if(toRoot!=fromRoot){
        this.getLinkList();
      }
    }
  },
  created(){
    this.getLinkList();
  },
  methods:{
    toggleSideBar() {
      this.$store.dispatch('toggleSideBar')
    },
    //递归子路由分组
    getRouteGroup(parentRoute){
      let groupRoute=[];
      if(parentRoute.meta.subtitle && typeof parentRoute.meta.subtitle=='object' && parentRoute.meta.subtitle.length>0){//若subttile为数组，则路由需要分组显示
        parentRoute.meta.subtitle.forEach((title,index)=>{
          let routeList=parentRoute.children.filter((route)=>{ //筛选meta.group与subtitle相匹配的路由
            if(route.children && route.children.length>0){
              route.group=this.getRouteGroup(route)//若子路由有子路由，则递归处理
              console.log(route.group)
            }
            if(route.meta && !route.meta.hasOwnProperty('group'))  route.meta.group=0
            return route.meta && route.meta.group==index
          })
          groupRoute.push({subtitle:title,route:routeList})
        })
      }else{//若subtitle为字符串，则不进行路由分组
        groupRoute.push({subtitle:parentRoute.meta.subtitle,route:parentRoute.children})
      }
      return groupRoute
    },
    getLinkList(){
      let root=this.$route.meta.root;
      let arryRoute=[];
      for(let route of this.permission_routers){
        if (route.name && route.name==root) {
          this.routeTitle=route.meta.title
          arryRoute.push(route);
          break;
        }
      }

      arryRoute.forEach(route=>{ //遍历当前路由
          route.group=this.getRouteGroup(route)
      })
      console.log(arryRoute);
      this.routeList=arryRoute;
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  .hamburger-container{
    position: absolute;
    right: 0;
    top:0;
    z-index: 99999;
  }
  .nav-name{
    height: 72px;
    line-height: 24px;
    padding: 24px 30px;
    padding-right: 10px;
    color: #666;
    font-weight: bold;
    font-size: 18px;
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/index.vue